export const initialState = {
  webinars: [],
  nextToken: null,
  nextTokens: { 1: null },
  error: null,
  loading: false,
  webinarDetail: {},
  webinarDetailLoading: false,
  webinarDetailError: null,
  registrationLoading: false,
  registrationError: null,
  registration: {},
  registrationStatusLoading: false,
  registrationStatusError: null,
  registrationStatus: {},
  isRegistrationStatusError: false,
  certificateLoading: false,
  certificateError: null,
  certificate: {},
  certificateVerificationLoading: false,
  certificateVerificationError: null,
  certificateVerification: {},
  consultanWebinars: [],
  consultanWebinarLoading: false,
  consultanWebinarError: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "REQUEST_LIST_WEBINAR":
      return {
        ...state,
        webinars: [],
        nextToken: null,
        nextTokens:
          action.payload.page === 1
            ? initialState.nextTokens
            : state.nextTokens,
        error: null,
        loading: true,
      };
    case "LIST_WEBINAR_SUCCESS":
      return {
        ...state,
        webinars: action.payload.items,
        nextTokens: {
          ...state.nextTokens,
          [action.payload.nextPage]: action.payload.nextToken,
        },
        loading: false,
      };
    case "LIST_WEBINAR_ERROR":
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case "REQUEST_GET_WEBINAR_DETAIL":
      return {
        ...state,
        webinarDetail: {},
        webinarDetailError: null,
        webinarDetailLoading: true,
      };
    case "GET_WEBINAR_DETAIL_SUCCESS":
      return {
        ...state,
        webinarDetail: action.payload.item,
        webinarDetailLoading: false,
      };
    case "GET_WEBINAR_DETAIL_ERROR":
      return {
        ...state,
        webinarDetailLoading: false,
        webinarDetailError: action.error,
      };
    case "REQUEST_WEBINAR_REGISTRATION":
      return {
        ...state,
        request: action.payload.request,
        registrationLoading: true,
        registrationError: null,
        registration: {},
      };
    case "WEBINAR_REGISTRATION_SUCCESS":
      return {
        ...state,
        request: null,
        registrationLoading: false,
        registration: action.payload.registration,
      };
    case "WEBINAR_REGISTRATION_ERROR":
      return {
        ...state,
        request: null,
        registrationLoading: false,
        registrationError: action.error,
      };
    case "REQUEST_GET_WEBINAR_REGISTRATION_STATUS":
      return {
        ...state,
        registrationStatusLoading: true,
        isRegistrationStatusError: false,
        registrationStatusError: null,
        registrationStatus: {},
      };
    case "GET_WEBINAR_REGISTRATION_STATUS_SUCCESS":
      return {
        ...state,
        registrationStatusLoading: false,
        registrationStatus: action.payload.status,
      };
    case "GET_WEBINAR_REGISTRATION_STATUS_ERROR":
      return {
        ...state,
        registrationStatusLoading: false,
        isRegistrationStatusError: true,
        registrationStatusError: action.error,
      };
    case "REQUEST_GET_WEBINAR_CERTIFICATE":
      return {
        ...state,
        certificateRequest: action.payload?.request,
        certificateLoading: true,
        certificateError: null,
        certificate: {},
      };
    case "GET_WEBINAR_CERTIFICATE_SUCCESS":
      return {
        ...state,
        certificateRequest: null,
        certificateLoading: false,
        certificate: action.payload.certificate,
      };
    case "GET_WEBINAR_CERTIFICATE_ERROR":
      return {
        ...state,
        certificateRequest: null,
        certificateLoading: false,
        certificateError: action.error,
      };
    case "REQUEST_VERIFY_WEBINAR_CERTIFICATE":
      return {
        ...state,
        certificateVerificationLoading: true,
        certificateVerificationError: null,
        certificateVerification: {},
      };
    case "VERIFY_WEBINAR_CERTIFICATE_SUCCESS":
      return {
        ...state,
        certificateVerificationLoading: false,
        certificateVerification: action.payload.verification,
      };
    case "VERIFY_WEBINAR_CERTIFICATE_ERROR":
      return {
        ...state,
        certificateVerificationLoading: false,
        certificateVerificationError: action.error,
      };
    case "REQUEST_GET_CONSULTANT_WEBINARS":
      return {
        ...state,
        consultantWebinars: [],
        consultantWebinarLoading: true,
        consultantWebinarError: null,
      };
    case "GET_CONSULTANT_WEBINARS_SUCCESS":
      return {
        ...state,
        consultantWebinars: action.payload.items,
        consultantWebinarLoading: false,
      };
    case "GET_CONSULTANT_WEBINARS_ERROR":
      return {
        ...state,
        consultantWebinarLoading: false,
        consultantWebinarError: action.error,
      };
    case "CLEAR_WEBINAR_CERTIFICATE":
      return {
        ...state,
        certificateRequest: null,
        certificateError: null,
        certificateLoading: false,
        certificate: {},
        certificateVerification: {},
        certificateVerificationError: null,
      };
    case "CLEAR_WEBINAR_REGISTRATION":
      return {
        ...state,
        registrationError: null,
        registrationLoading: false,
        registrationStatus: {},
        registrationStatusError: null,
        registration: {},
      };
    case "CLEAR_WEBINAR_ERRORS":
      return {
        ...state,
        certificateError: null,
        registrationError: null,
      };
    case "CLEAR_WEBINAR_DETAIL":
      return {
        ...state,
        webinarDetail: {},
        webinarDetailError: null,
      };
    default:
      return state;
  }
};
